// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
import App from './App'
import router from './router'
import Navigation from 'vue-navigation'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import './assets/css/common.css'
import 'animate.css'
import './assets/js/common.js'
import "./assets/css/quill.core.css";
import "./assets/css/fonts.css";
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from 'vue-baidu-map'
import ElementUI from 'element-ui';
import elementEn from 'element-ui/lib/locale/lang/en'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'
import { i18n } from './i18n/index' //国际化
Vue.use(ElementUI, { locale: i18n.locale === 'en' ? elementEn : elementZh });
Vue.use(BaiduMap,{ak:'18YKtjzxMbGrjCM0oZBNRx74PoyyiGUu'})
Vue.use(Navigation, {router})
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js